const axios = require('axios');
axios.defaults.baseURL='https://business.id-photo-verify.com';
axios.defaults.withCredentials=true;

const login = (email, password) => axios.post('/business_admin/login', {email,	password})
const getAPPInfo=(params)=> axios.post(`/baweb/get_webapp`,params);
const createApp=(params)=> axios.post(`/baweb/create_webapp`,params);
const modifyApp=(params)=> axios.post(`/baweb/change_webapp`,params);

const modifyWxParams=(params)=> axios.post(`/baweb/change_wechat_app`,params);
const modifyAlipayParams=(params)=> axios.post(`/baweb/change_alipay_app`,params);

const getUploadHost =()=> axios.get(`/applet_common/upload_file_url`);
const specSearch=(keyword)=> axios.get(`/baweb/search_specs?keyword=${keyword}`);
const getUsers=(params)=> axios.post(`/baweb/admin_get_users` ,params);
const getOrders=(params)=> axios.post(`/baweb/admin_get_orders` ,params);

const createChargeOrder=(params)=> axios.post(`/baweb/app_recharge` ,params);
const pollingChargeOrder=(params)=> axios.post(`/baweb/recharge_confirm` ,params);

const getVCodeForRegister = (phone) =>axios.get(`https://apicall.id-photo-verify.com/api/captcha?phone=${phone}`);
const register = (params) =>axios.post(`https://apicall.id-photo-verify.com/api/register_v2`,params);

export {
	login,
	getAPPInfo,
	createApp,
	modifyApp,
	modifyWxParams,
	modifyAlipayParams,
	specSearch,
	getUploadHost,
	getUsers,
	getOrders,
	createChargeOrder,
	pollingChargeOrder,
	getVCodeForRegister,
	register
}